export default __webpack_public_path__ + "static/media/th.1366e19e.svg";